module.exports = __webpack_public_path__ + "assets/587eda355a00daac34207bfa096f5050.mp3";